import React from 'react';
import { Paper, Button, Modal } from '@material-ui/core';

export const WaitlistToAttendeeConfirmationModal = ({
  showModal,
  setShowModal,
  handleConfirm,
  wouldBeOverbooked,
}: {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  handleConfirm: () => void;
  wouldBeOverbooked: boolean;
}) => {
  const titleCopy = wouldBeOverbooked
    ? 'Add Waitlisted Employees to Event · Over Capacity! '
    : 'Add Waitlisted Employees to Event';

  const bodyCopy = wouldBeOverbooked ? (
    <>
      Heads up - <strong>adding these persons will exceed the event&apos;s listed capacity</strong>.
      Are you sure you want to continue? they&apos;ll get an email confirming their sign-up and can
      cancel anytime through the Deed web or mobile app if they can&apos;t make it.
    </>
  ) : (
    <>
      Are you sure you want to add the selected persons to the event? They&apos;ll receive an email
      confirming their sign-up. If they can&apos;t attend, they&apos;ll need to cancel through the
      Deed web or mobile app.
    </>
  );

  return (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      disableAutoFocus
      style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}
    >
      <Paper style={{ padding: 32, width: 800, display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            fontSize: 20,
            fontWeight: 500,
            paddingBottom: 16,
          }}
        >
          {titleCopy}
        </div>
        <div style={{ paddingBottom: 16 }}>{bodyCopy}</div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            style={{ marginRight: 16, display: 'flex' }}
            onClick={() => {
              setShowModal(false);
            }}
          >
            Cancel
          </Button>
          <Button
            style={{ display: 'flex' }}
            color="primary"
            variant="contained"
            onClick={handleConfirm}
          >
            Add
          </Button>
        </div>
      </Paper>
    </Modal>
  );
};
